import React, { useEffect, useState } from 'react';
import { resetPass } from '../../actions/AuthAction'
import { useDispatch, useSelector } from 'react-redux'
import './Auth.css'
import Logo from '../../img/appiconcrop3.png'
import { Link, useNavigate } from 'react-router-dom'

const Reset = () => {
  const dispatch = useDispatch();
  const {loading, error, message} = useSelector((state)=>state.authReducer);
  const navigate = useNavigate();
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showRedirectMessage, setShowRedirectMessage] = useState(false);

  useEffect(()=> {
    if (error !== null) {
        const signupValEl = document.getElementById("auth_reset_validation");
        signupValEl.classList.remove("General-hidden")
        switch (error) {
            case 404:
                signupValEl.innerText = "User not found";
                break;
            case 409:
                signupValEl.innerText = "Token and Password are required.";
                break;
            case 400:
                signupValEl.innerText = "Invalid or expired token";
                break;
            case 500:
                signupValEl.innerText = "A server error has occurred.  Please try again later.";
                break;
            default:
                signupValEl.innerText = "";
        }
    }
    if (message === "Password changed successfully.") {
        setShowRedirectMessage(true);
  
        setTimeout(() => {
          navigate('/auth');
        }, 3000);
      }
  }, [error, message])

  const handleSubmit = (e) => {
    e.preventDefault();
    if (newPassword !== "" && confirmPassword !== "") {
        if (newPassword === confirmPassword) {
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            const token = urlParams.get('token')
            console.log(token);
            const data = {
                newPassword: newPassword,
                token: token
            }
            dispatch(resetPass(data))
        } else {
          alert("Passwords do not match");
        }
    }
  };

  return (
    <div className="Auth">
        <div className="auth-left">
            <Link style={{textDecoration: "none", color: "inherit"}} to={'/landing'}><img src={Logo} alt="" className='auth-logo' /></Link>
        </div>
        <div className="auth-right">
            <form action="" className="input-form" onSubmit={handleSubmit}>
                <h3>Reset Password</h3>
                
                <input 
                    type="password"
                    placeholder='New Password'
                    className='signupInput'
                    name='password'
                    id="reset_password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                />
                <input 
                    type="password"
                    placeholder='Confirm Password'
                    className='signupInput'
                    name='confirmPassword'
                    id="forgot_confirm"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                />
                <div id="auth_reset_validation" className='General-validationError General-hidden'></div>
                <button className="button signupButton" type="submit" disabled={loading}>
                    {loading ? "Loading..." : "Update"}
                </button>
                {showRedirectMessage && (
                <div id="redirecting-message" className="success">
                 Password changed. Redirecting you to the login page...
                </div>
                )}  
            </form>
        </div>
    </div>
    
  );
};

export default Reset;